import { WorkingCenterCounterModelType } from '@teinor/erp/types/company/workingCenter/workingCenterCounter'
import { MediumModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValueReadOnly } from '../../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { useParams } from 'react-router'
import { OnSubmit } from '../../../../../../../../../../forms/TwinForm/types'
import { useCallback } from 'react'
import { changeErrorMessage } from '../../../../../../../../../../utils/reducers/reduxDispatch'
import { CheckboxMargin } from '../../../../../../../../../../forms/Checkbox'

interface ModalCECounterWorkingCenterProps extends ModalEditComponentProps {}

const ModalCECounterWorkingCenter: React.FC<ModalCECounterWorkingCenterProps> = ({setOpened, onSubmit, allRowData, userPermissions}) => {
    const { t } = useTwinTranslation()
    const { handleOnError} = useModalCECounterWorkingCenter()
    const { id } = useParams()
    const fields: FormRender<WorkingCenterCounterModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'serie',
                    label: t('serie', 'Serie'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'prefix',
                    label: t('prefix', 'Prefijo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    readOnly: allRowData?.id
                },
                {
                    name: 'active',
                    component: 'Custom',
                    render: () => allRowData?.active ? <CheckboxMargin label={t('active', 'Activo')} checked={true} /> : null
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: allRowData?.WorkingCenterId || id
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                }
            ]
        },
        {
            cols: 3,
            title: t('counters', 'Contadores'),
            elements: [
                {
                    name: 'buy_order',
                    label: t('buyOrder', 'Pedido de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'buy_deliverynote',
                    label: t('buyDeliveryNote', 'Albarán de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'buy_invoice',
                    label: t('buyInvoice', 'Factura de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_buy_deliverynote',
                    label: t('refundBuyDeliveryNote', 'Devolución Albarán'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_buy_invoice',
                    label: t('refundBuyInvoice', 'Devolución Factura de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'other_expenses',
                    label: t('otherExpenses', 'Otros gastos'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sell_order',
                    label: t('sellOrder', 'Venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sell_deliverynote',
                    label: t('sellDeliveryNote', 'Albarán de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sell_invoice',
                    label: t('sellInvoice', 'Factura de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_sell_deliverynote',
                    label: t('refundSellDeliveryNoteShort', 'Dev. Albarán de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_sell_invoice',
                    label: t('refundSellInvoiceShort', 'Dev. Factura de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'quote_order',
                    label: t('quote', 'Presupuesto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'vat_supported',
                    label: t('vatSupported', 'IVA soportados'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'work_sheet',
                    label: t('workSheet', 'Hoja de trabajo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sell_ticket',
                    label: t('ticket', 'Ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_sell_ticket',
                    label: t('refundTicketShort', 'Dev. Ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'cash_register',
                    label: t('cashRegister', 'Caja'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'sell_ticket_reserved',
                    label: t('sellTicketReserved', 'Reserva de ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'invoice_ticket',
                    label: t('sellTicketInvoice', 'Ticket factura'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'refund_invoice_ticket',
                    label: t('sellTicketInvoiceRefund', 'Dev. ticket factura'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'manufacturing',
                    label: t('manufacturing', 'Fabricación'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'adjustment_deliverynote',
                    label: t('adjustmentDeliverynote', 'Albarán de regularización'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
            ]
        },
        {
            cols: 3,
            title: t('prefixes', 'Prefijos'),
            elements: [
                {
                    name: 'prefix_buy_order',
                    label: t('buyOrder', 'Pedido de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_buy_deliverynote',
                    label: t('buyDeliveryNote', 'Albarán de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_buy_invoice',
                    label: t('buyInvoice', 'Factura de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_refund_buy_deliverynote',
                    label: t('refundBuyDeliveryNote', 'Devolución Albarán'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_buy_deliverynote || 'D'
                },
                {
                    name: 'prefix_refund_buy_invoice',
                    label: t('refundBuyInvoice', 'Devolución Factura de compra'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_buy_invoice || 'D'
                },
                {
                    name: 'prefix_other_expenses',
                    label: t('otherExpenses', 'Otros gastos'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_sell_order',
                    label: t('sellOrder', 'Venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_sell_deliverynote',
                    label: t('sellDeliveryNote', 'Albarán de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_sell_invoice',
                    label: t('sellInvoice', 'Factura de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_refund_sell_deliverynote',
                    label: t('refundSellDeliveryNoteShort', 'Dev. Albarán de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_sell_deliverynote || 'D'
                },
                {
                    name: 'prefix_refund_sell_invoice',
                    label: t('refundSellInvoiceShort', 'Dev. Factura de venta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_sell_invoice || 'D'
                },
                {
                    name: 'prefix_quote_order',
                    label: t('quote', 'Presupuesto'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_vat_supported',
                    label: t('vatSupported', 'IVA soportados'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_work_sheet',
                    label: t('workSheet', 'Hoja de trabajo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_sell_ticket',
                    label: t('ticket', 'Ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_refund_sell_ticket',
                    label: t('refundTicketShort', 'Dev. Ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_sell_ticket || 'D'
                },
                {
                    name: 'prefix_cash_register',
                    label: t('cashRegister', 'Caja'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'prefix_sell_ticket_reserved',
                    label: t('sellTicketReserved', 'Reserva de ticket'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_sell_ticket_reserved || 'R'
                },
                {
                    name: 'prefix_invoice_ticket',
                    label: t('sellTicketInvoice', 'Ticket factura'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_invoice_ticket || 'F'
                },
                {
                    name: 'prefix_refund_invoice_ticket',
                    label: t('sellTicketInvoiceRefund', 'Dev. ticket factura'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_refund_invoice_ticket || 'DF'
                },
                {
                    name: 'prefix_manufacturing',
                    label: t('manufacturing', 'Fabricación'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_manufacturing
                },
                {
                    name: 'prefix_adjustment_deliverynote',
                    label: t('adjustmentDeliverynote', 'Albarán de regularización'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    defaultValue: allRowData?.prefix_adjustment_deliverynote
                }
            ]
        },
    ]
    if (allRowData?.serie && userPermissions) {
        const parsedFields = valueOrDefaultValueReadOnly(fields, userPermissions, allRowData)
        return (
            <MediumModalCreateEdit setOpened={setOpened} onSubmit={onSubmit} fields={parsedFields} translations={{
                title: t('editSerie', 'Editar serie'),
                button: t('save', 'Guardar')
                }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} url={'/api/app/workingCenter/workingCenterCounter/updateWorkingCenterCounter'} >
            </MediumModalCreateEdit>
        )
    }
    return (
        <MediumModalCreateEdit setOpened={setOpened} onSubmit={onSubmit} fields={fields} translations={{
            title: t('createSerie', 'Crear serie'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} onChangeError={handleOnError} url={'/api/app/workingCenter/workingCenterCounter/createWorkingCenterCounter'} >
    </MediumModalCreateEdit>    
    )
}

const useModalCECounterWorkingCenter = () => {
    const { t } = useTwinTranslation()
    const errorMessage = t('prefixExists', 'El prefijo ya existe')
    const handleOnError: OnSubmit = useCallback(async (res: Response) => {
        const responseJSON = await res.json()
        if (responseJSON.errors[0].msg === 'This prefix already exists') {
            changeErrorMessage(errorMessage)
        }
    }, [errorMessage])
    return { handleOnError }
}

export default ModalCECounterWorkingCenter